import ProgramList from "src/components/ManageProgram/ProgramList";

export default function ManageProgram() {
  return (
    <div>
      <ProgramList/>
    </div>
  )
}